module.exports = __webpack_public_path__ + "media/2-er.4be97dfe.mp3";